import { cva } from 'class-variance-authority';

const spinnerStylesSAG = cva(['stroke-[#007993]', 'dark:stroke-[#00CCCC]']);

const spinnerStylesSHS = cva(['stroke-[#cf4b00]']);

export { spinnerStylesSAG, spinnerStylesSHS };
